<div>
  <div style="font-size: 40px; text-align: center; margin: 60px 20px; line-height: 40px">
    {{ 'maksut.vahvista-valitut' | translate | async }}
  </div>
  <div style="max-width: 1000px; margin: 20px auto">
    <div style="margin: 20px" tunnistautuminen-nets-maksujen-vahvistus-pankit [maksutVahvistusData]="data" [actionAfterSuccess]="'continue-payment-approval'"></div>
  </div>
</div>
